import React from 'react';
import nbrLogo from "../assets/images/common/header/nbr-logo.png";
import nbrLogoWithoutText from "../assets/images/common/header/govt_logo.png";
import bdCustomsLogo from "../assets/images/common/header/bd-customs-logo.png";
import bdCustomsLogoWithText from "../assets/images/common/header/bd-customs-logo-with-text.png";

const Header = () => {
    return (
        <header className="header">
            <div className="custom-container">
                <div
                    className="header__container py-2 d-flex justify-content-start justify-content-xl-between align-items-center"
                >
                    <img
                        className="nbr-logo ml-4 d-none d-xl-block"
                        src={nbrLogo}
                        alt="National board of revenue logo"
                    />
                    <img
                        className="nbr-logo-without-text d-none d-block d-xl-none"
                        src={nbrLogoWithoutText}
                        alt="National board of revenue logo"
                    />
                    <img
                        className="bd-customs-logo ml-4 d-block d-xl-none"
                        src={bdCustomsLogo}
                        alt="Bangladesh customs logo"
                    />
                    <img
                        className="bd-customs-logo-with-text d-none d-xl-block"
                        src={bdCustomsLogoWithText}
                        alt="Bangladesh customs logo"
                    />
                </div>
            </div>
        </header>
    );
};

export default Header;
